import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import A11y from 'chameleon/packages/blue-book-player/utility/a11y';

const MoreMenuItem = (props) => {
  const buttonRef = useRef(null);
  const { itemName, icon, autoFocus, onClick, iconClassName } = props;

  useEffect(() => {
    if (autoFocus) {
      buttonRef?.current?.focus();
    }
  }, [autoFocus]);

  return (
    <A11y>
      <div
        className="flex flex-row bb-desktop:py-[16px] bb-mobile:py-[12px] bb-mobile:px-[16px] bb-desktop:px-[24px] bb-desktop:first:pt-[24px] leading-[1.5em] hover:bg-bluebook-light-gray hover:cursor-pointer hover:underline"
        role="button"
        ref={buttonRef}
        tabIndex={0}
        aria-label={itemName}
        onClick={onClick}
      >
        <div className="flex bb-desktop:w-[20px] bb-mobile:w-[30px]">
          <img
            className={'bb-mobile:max-w-[30px] ' + iconClassName}
            aria-hidden="true"
            src={icon}
            alt={`${itemName} icon`}
          />
        </div>
        <div className="ml-[15px] bb-mobile:ml-[20px]">{itemName}</div>
      </div>
    </A11y>
  );
};

MoreMenuItem.propTypes = {
  itemName: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  iconClassName: PropTypes.string,
};

MoreMenuItem.defaultProps = {
  iconClassName: '',
};

export default MoreMenuItem;
